define([
    'web/common/api'
], function(
    CommonApi
){
    var Api = CommonApi.Api;
    return {
        multiPromise: CommonApi.multiPromise,
        getCooperateCfgApi: new Api('/s/sitecooperate/getCfg'),
        addCooperateApi: new Api('/s/sitecooperate/add', {type: 'POST'}),
        uploadApi: new Api('/m/s/upload', {
            type:'POST',
            processData: false,
            contentType: false
        }),
        getCommonEnumApi: new Api('/m/s/common/enum')
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/api.js
// module id = 202
// module chunks = 0